/**
 * Generate a Role based on the user and profile linked by the role
 */
export const generateRole = (user, profile, permissionLevel = "owner") => {
    return {
        type: profile.type,
        permissionLevel: permissionLevel,
        userId: user._id,
        profileId: profile._id,
    };
};
/**
 * Generate a Role ID based on the user and profile linked by the role
 */
export const generateRoleId = (user, profile) => {
    if (profile.type === "retail-buyer") {
        return `${user._id}-retail`;
    }
    else {
        return `${user._id}-${profile._id}`;
    }
};
/**
 * Generate an Admin Role for user
 */
export const generateAdminRole = (user) => {
    return {
        type: "admin",
        permissionLevel: "owner",
        userId: user._id,
    };
};
/**
 * Generate a Role ID based on the user and profile linked by the role
 */
export const generateAdminRoleId = (user) => {
    return `${user._id}-admin`;
};
const makeIsRoleType = (types) => (type) => {
    return types.some((t) => t === type);
};
const makeIsRole = (types) => (role) => {
    const isRoleType = makeIsRoleType(types);
    return !!role && isRoleType(role.type);
};
const makeAssertIsRole = (types) => (role) => {
    var _a;
    if (!makeIsRole(types)(role))
        throw new Error(`Invalid role. Expected "${types.join(" | ")}", received: '${(_a = role === null || role === void 0 ? void 0 : role.type) !== null && _a !== void 0 ? _a : "no-role"}'`);
};
const makeRoleGroupUtils = (types) => ({
    isRole: makeIsRole(types),
    isRoleType: makeIsRoleType(types),
});
export const assertRoleExists = (role) => {
    if (!role)
        throw new Error(`Role does not exist.`);
};
// Q: Why does `makeRoleGroupUtils` not include `assertIsRole`?
//
// A: Typescript requires explicit typing on assertion functions. This means it can't be returned from
//    the generic and used (even though the type look correct!) until it is casted.
//    The solution to this is adding a tiny bit of boiler plate -- for every new group,
//    also be sure to add an `assertIs[Group]` function, with `AssertHasType` explicitly casting it.
const BUYER = ["retail-buyer", "wholesale-buyer"];
export const { isRole: isBuyer, isRoleType: isBuyerType } = makeRoleGroupUtils(BUYER);
export const assertIsBuyer = makeAssertIsRole(BUYER);
const ENTERPRISE = ["grower", "wholesale-buyer", "coop"];
export const { isRole: isEnterprise, isRoleType: isEnterpriseType } = makeRoleGroupUtils(ENTERPRISE);
export const assertIsEnterprise = makeAssertIsRole(ENTERPRISE);
const SELLER = ["grower", "coop"];
export const { isRole: isSeller, isRoleType: isSellerType } = makeRoleGroupUtils(SELLER);
export const assertIsSeller = makeAssertIsRole(SELLER);
// Individual Roles:
const GROWER = ["grower"];
export const { isRole: isGrower, isRoleType: isGrowerType } = makeRoleGroupUtils(GROWER);
export const assertIsGrower = makeAssertIsRole(GROWER);
const RETAIL = ["retail-buyer"];
export const { isRole: isRetail, isRoleType: isRetailType } = makeRoleGroupUtils(RETAIL);
export const assertIsRetail = makeAssertIsRole(RETAIL);
const COOP = ["coop"];
export const { isRole: isCoop, isRoleType: isCoopType } = makeRoleGroupUtils(COOP);
export const assertIsCoop = makeAssertIsRole(COOP);
const WHOLESALE = ["wholesale-buyer"];
export const { isRole: isWholesale, isRoleType: isWholesaleType } = makeRoleGroupUtils(WHOLESALE);
export const assertIsWholesale = makeAssertIsRole(WHOLESALE);
//# sourceMappingURL=roles.js.map